import { useToast } from "@circle-react-uikit/ToastV2";
import { useCallback } from "react";
import type { MutableRefObject } from "react";
import { useFormContext } from "react-hook-form";

interface UseUpgradeAcceptanceErrorProps {
  isMountedRef: MutableRefObject<boolean>;
  onAcceptanceStateChange: (hasStarted: boolean) => void;
  readOnlyProcessing: boolean;
  setIsAccepted: (isAccepted: boolean) => void;
  setIsProcessing: (isProcessing: boolean) => void;
}

export const useUpgradeAcceptanceError = ({
  isMountedRef,
  onAcceptanceStateChange,
  readOnlyProcessing,
  setIsAccepted,
  setIsProcessing,
}: UseUpgradeAcceptanceErrorProps) => {
  const { clearErrors, setError } = useFormContext();
  const { error: showErrorToast } = useToast();

  return useCallback(
    (message: string) => {
      if (!isMountedRef.current) return;
      setIsProcessing(false);
      if (readOnlyProcessing) {
        setError("root", { message });
        return;
      }
      setIsAccepted(false);
      onAcceptanceStateChange(false);
      clearErrors();
      showErrorToast(message);
    },
    [
      clearErrors,
      isMountedRef,
      onAcceptanceStateChange,
      readOnlyProcessing,
      setError,
      setIsAccepted,
      setIsProcessing,
      showErrorToast,
    ],
  );
};
